// Assigns values to the destination that match the source.
export const assignIfDefined = <TDest, TSource extends TDest>(
  dest: TDest,
  source: TSource
): TDest => {
  const destPropNames = Object.getOwnPropertyNames(dest) as (keyof TDest)[];
  for (const modelpropName of destPropNames) {
    dest[modelpropName] = source[modelpropName];
  }
  return dest;
};
